export const FISHERMAN_WEBSITE_COMPONENT_NAME = 'fishermanWebsiteComponent';
